export const RESOURCE_NOT_FOUND = 404;
